"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString = void 0;
const isString = (value) => typeof value === 'string';
exports.isString = isString;
